import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteCargoModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/cargos',
    nameForTitle: 'Cargo',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteCargoModal
